import { IDiemQuyDoi } from "../../../model/response/category/IDiemQuyDoi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDiemQuyDoiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IDiemQuyDoi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDiemQuyDoi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDiemQuyDoi,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eDiemQuyDoiActionIds = generateActionTypeIds(eDiemQuyDoiActionsObj, "DIEM_QUY_DOI");
export type IDiemQuyDoiActionTypes = IGenericActionType<typeof eDiemQuyDoiActionsObj, "DIEM_QUY_DOI">;